import React from 'react';
import { observer } from 'mobx-react';

import { Heading, Box, SvgIcon, Paragraph, Text } from 'components';
import { PortalLink } from 'apps/client/components/PortalLink';
import { Link } from 'core/routing';
import { ChangePortalBanner } from 'apps/client/components/ChangePortalBanner';

import { ArrowLeft } from 'icons';
import { clientStore } from 'apps/client/app';

import { SpaceLink } from 'apps/shared';
import type { ShipmentQuoteAppT } from 'apps/shipmentQuote/app';
import type QuotePageAppManager from 'apps/shipmentQuote/QuotePage/appManager';
import { HeaderActions } from './HeaderActions';

const alignCenterStyle = {
  display: 'flex',
  alignItems: 'center',
};

interface QuotePageHeaderProps {
  quote: ShipmentQuoteAppT;
  quoteAppManager: QuotePageAppManager;
  isPayButtonLoading: boolean;
}

export const QuotePageHeader = observer(function QuotePageHeader({
  quote,
  quoteAppManager,
  isPayButtonLoading,
}: QuotePageHeaderProps) {
  const spacePath = clientStore.activeSpace?.path;
  const order = quote?.orders?.apps[0];
  const isIntermediator = clientStore.hasRole('INTERMEDIATOR');

  const isPaymentDisabled = quote.isExpired;

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Box sx={alignCenterStyle}>
          <Heading level={2} size='large' margin='0 16px 0 0'>
            Quote{' '}
            <span style={{ fontWeight: 'normal' }}>
              #
              <span data-test-id='multi-quote-decimal-id'>
                {quote?.decimalId}
              </span>
            </span>
          </Heading>
          <PortalLink name='workspace.quotes' params={{ spacePath }}>
            <Box sx={alignCenterStyle}>
              <SvgIcon
                sx={{ marginRight: 8 }}
                icon={<ArrowLeft />}
                color='primary'
              />
              <Paragraph variant='accent'>Back to my quotes</Paragraph>
            </Box>
          </PortalLink>
        </Box>
        <HeaderActions
          loading={isPayButtonLoading}
          disabled={isPaymentDisabled}
          quoteAppManager={quoteAppManager}
        />
      </Box>
      {isIntermediator && quote && (
        <SpaceLink
          variant='primary'
          label='Quote for'
          size='medium'
          space={quote?.customerSpace}
        />
      )}
      {order && (
        <Box>
          <Link name='order' params={{ orderId: order.decimalId }}>
            <Text size='small'>
              {/* TODO: Alex add color mapping */}
              <span style={{ color: '#000' }}>Order</span>: {order.decimalId}
            </Text>
          </Link>
        </Box>
      )}
      <ChangePortalBanner />
    </Box>
  );
});
